// extracted by mini-css-extract-plugin
module.exports = {"geoc":"Map_geoc__252X-"};